import Icon from "./IconBase.js";
const Practiceicon = (props) => {
  return (
    <Icon
      width="24"
      height="24"
      viewBox="-6 -3 20 20"
      style={{ borderColor: "white" }}
      {...props}
    >
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.04484 1.91176H7.90321C7.75465 1.50099 7.35459 1.20587 6.88542 1.20587H6.46385C6.31531 0.795031 5.91504 0.5 5.44581 0.5C4.97659 0.5 4.57631 0.795031 4.42778 1.20589H4.00621C3.53701 1.20589 3.13697 1.50099 2.98841 1.91178H1.84679C1.25144 1.91178 0.76709 2.38677 0.76709 2.97059V11.4412C0.76709 12.025 1.25144 12.5 1.84679 12.5H9.04486C9.6402 12.5 10.1246 12.025 10.1246 11.4412V2.97059C10.1246 2.38674 9.6402 1.91176 9.04484 1.91176ZM3.64641 2.26471C3.64641 2.07011 3.80785 1.91176 4.00632 1.91176H4.72613C4.92488 1.91176 5.08604 1.75375 5.08604 1.55882C5.08604 1.36422 5.24748 1.20587 5.44594 1.20587C5.64438 1.20587 5.80585 1.36419 5.80585 1.55882C5.80585 1.75375 5.96698 1.91176 6.16576 1.91176H6.88557C7.08401 1.91176 7.24548 2.07008 7.24548 2.26471V2.61765H3.64641V2.26471ZM9.04481 11.7941C9.24328 11.7941 9.40472 11.6358 9.40472 11.4412H9.40474V2.9706C9.40474 2.77597 9.24328 2.61765 9.04484 2.61765H7.96514V2.9706C7.96514 3.16552 7.80398 3.32354 7.60523 3.32354H3.28639C3.08762 3.32354 2.92649 3.16552 2.92649 2.9706V2.61765H1.84676C1.6483 2.61765 1.48686 2.77599 1.48686 2.9706V11.4412C1.48686 11.6358 1.64832 11.7941 1.84676 11.7941H9.04481Z"
          fill="#757575"
        />
        <path
          d="M4.36592 5.48315H2.92631C2.72756 5.48315 2.56641 5.64117 2.56641 5.8361C2.56641 6.03101 2.72754 6.18904 2.92631 6.18904H4.36592C4.56467 6.18904 4.72583 6.03103 4.72583 5.8361C4.7258 5.64117 4.56467 5.48315 4.36592 5.48315Z"
          fill="#757575"
        />
        <path
          d="M4.36592 8.9707H2.92631C2.72756 8.9707 2.56641 9.12872 2.56641 9.32365C2.56641 9.51858 2.72754 9.67659 2.92631 9.67659H4.36592C4.56467 9.67659 4.72583 9.51858 4.72583 9.32365C4.72583 9.12872 4.56467 8.9707 4.36592 8.9707Z"
          fill="#757575"
        />
        <path
          d="M8.21956 4.88072C8.07903 4.74288 7.85115 4.74288 7.71062 4.88074L6.88538 5.68999L6.42005 5.23369C6.27952 5.09585 6.05163 5.09585 5.91108 5.23369C5.77053 5.37152 5.77053 5.59498 5.91108 5.73281L6.63089 6.4387C6.70118 6.50761 6.79329 6.54206 6.8854 6.54206C6.97751 6.54206 7.06962 6.50761 7.13989 6.43868L8.21961 5.37987C8.36012 5.24201 8.36012 5.01855 8.21956 4.88072Z"
          fill="#757575"
        />
        <path
          d="M7.39435 9.32348L7.85968 8.86715C8.00021 8.72934 8.00021 8.50586 7.85966 8.36805C7.71912 8.23021 7.49124 8.23021 7.35069 8.36805L6.88538 8.82435L6.42005 8.36803C6.27952 8.23019 6.05163 8.23019 5.91108 8.36803C5.77053 8.50586 5.77053 8.72931 5.91108 8.86715L6.37641 9.32348L5.91108 9.77981C5.77053 9.91764 5.77053 10.1411 5.91108 10.2789C5.98135 10.3478 6.07348 10.3823 6.16559 10.3823C6.2577 10.3823 6.34981 10.3478 6.42007 10.2789L6.8854 9.8226L7.35073 10.2789C7.42097 10.3478 7.51311 10.3823 7.60522 10.3823C7.69733 10.3823 7.78944 10.3478 7.8597 10.2789C8.00026 10.1411 8.00026 9.91762 7.8597 9.77978L7.39435 9.32348Z"
          fill="#757575"
        />
      </svg>
    </Icon>
  );
};
export default Practiceicon;
